
import React from 'react';
import Moment from 'react-moment';

import moment from 'moment';
import 'moment/locale/es-mx';
import 'moment-timezone';
import servicioObjetos from './ServicioObjetos';

Moment.globalMoment = moment;
Moment.globalLocale = 'es-mx';
Moment.globalTimezone = 'America/Mexico_City';
Moment.globalLocal = true;


const formatoModena = new Intl.NumberFormat('es-MX', {
  style: 'currency',
  currency: 'MXN',
});

//const opcionesFecha = { timeZone: 'America/Mexico_City', weekday: "long", year: "numeric", month: "long", day: "numeric", hour: "numeric", minute: "numeric", second: "numeric", hour12: "false" };
const servicioFormatos = {

  formatearModena(valor) {
    return formatoModena.format(valor);
  },

  formatearFecha(valor) {
    if (servicioObjetos.esObjetoVacio(valor)) {
      return null;
    } else {
      let fecha = new Date(valor);
      return <Moment date={fecha} format="DD-MM-YYYY"></Moment>

    }
  },

  formatearFechaTablas(valor) {
    if (servicioObjetos.esObjetoVacio(valor)) {
      return null;
    } else {
      let fecha = new Date(valor);
      return <Moment date={fecha} format="DD/MM/YYYY"></Moment>

    }
  },

  formatearFechaSinSegundos(valor) {
    if (servicioObjetos.esObjetoVacio(valor)) {
      return null;
    } else {
      let fecha = new Date(valor);
      return <Moment date={fecha} format="DD-MMMM-YYYY"></Moment>;
    }
  },
  formatearFechaString(valor) {
    if (servicioObjetos.esObjetoVacio(valor)) {
      return null;
    } else {
      let fecha = moment(valor).format('YYYY-MM-DD HH:mm:ss');
      return fecha;
    }
  },
  formatearFechaStringArchivoIdse(valor) {
    if (servicioObjetos.esObjetoVacio(valor)) {
      return null;
    } else {
      let fecha = moment(valor).format('DDMMYYYY');
      return fecha;
    }
  },

  /**
   * Función encargada de formatear el tipo de movimiento del IDSE
   * @param {*} valor 
   */
  formatoTipoMovimiento(valor) {
    let respuesta = "";
    if (servicioObjetos.esObjetoVacio(valor))
      return respuesta;
    valor = valor.trim();
    switch (valor) {
      case "01":
        respuesta = "01 - Alta";
        break;
      case "08":
        respuesta = "08 - Reingreso";
        break;
      case "09":
          respuesta = "09 - Carga Inic.";
          break;
      case "07":
        respuesta = "07 - Modificación";
        break;
      case "02":
        respuesta = "02 - Baja";
        break;

      case "11":
        respuesta = "11 - Ausentismo";
        break;
      case "12":
        respuesta = "12 - Incapacidad";
        break;
      case "15":
        respuesta = "15 - Inicio de Crédito de Vivienda";
        break;
      case "16":
        respuesta = "16 - Fecha de Suspensión de Descuento";
        break;
      case "17":
        respuesta = "17 - Reidsenube de Descuento";
        break;
      case "18":
        respuesta = "18 - Modificación de Tipo de Descuento";
        break;
      case "19":
        respuesta = "19 - Modificación de Valor de Descuento";
        break;
      case "20":
        respuesta = "20 - Modificación de Número de Crédito";
        break;
      default:
        break;
    }
    return respuesta;
  },
  /**
   * Función para darle formato a tipo de rama
   * @param {*} valor 
   */
  formatoRama(valor) {
    let respuesta = "";
    if (servicioObjetos.esObjetoVacio(valor))
      return respuesta;
    valor = valor.trim();
    switch (valor) {
      case "1":
        respuesta = "1 Riesgos de trabajo";
        break;
      case "2":
        respuesta = "2 Enfermedad General";
        break;
      case "3":
        respuesta = "3 Maternidad";
        break;
      case "4":
        respuesta = "4 Licencia 140 Bis";
        break;
      default:
        break;
    }
    return respuesta;
  },
  /**
   * Función encargada de darle formato a tipo de riesgo
   * @param {} valor 
   */
  formatoTipoRiesgo(valor) {
    let respuesta = "";
    if (servicioObjetos.esObjetoVacio(valor))
      return respuesta;
    valor = valor.trim();
    switch (valor) {
      case "1":
        respuesta = "1 Accidente de trabajo";
        break;
      case "2":
        respuesta = "2 Accidente de trayecto";
        break;
      case "3":
        respuesta = "3 Enfermedad Profecional";
        break;

      default:
        break;
    }
    return respuesta;
  },
  /**
   * Función para darle formato a Secuencia o concecuencias
   * @param {*} valor 
   */
  funcionSecuencia(valor) {
    let respuesta = "";
    if (servicioObjetos.esObjetoVacio(valor))
      return respuesta;
    valor = valor.trim();
    switch (valor) {
      case "0":
        respuesta = "0 Ninguna";
        break;
      case "1":
        respuesta = "1 Incapacidad Temporal";
        break;
      case "2":
        respuesta = "2 Valuación Inicial Provicional";
        break;
      case "3":
        respuesta = "3 Valuación Inicial Definitiva";
        break;
      case "4":
        respuesta = "4 Defunción";
        break;
      case "5":
        respuesta = "5 Recaida";
        break;
      case "6":
        respuesta = "6 Valuación Post. A la fecha Alta";
        break;
      case "7":
        respuesta = "7 Revaluación Provisional";
        break;
      case "8":
        respuesta = "8 Recaida sin alta medica";
        break;
      case "9":
        respuesta = "9 Revaluación Definitiva";
        break;
      default:
        break;
    }
    return respuesta;

  },
  /** funcion encargada de darle formato al valor Control de incapacidad */
  funcionControlIncapacidad(valor) {
    let respuesta = "";
    if (servicioObjetos.esObjetoVacio(valor))
      return respuesta;
    valor = valor.trim();
    switch (valor) {
      case "0":
        respuesta = "0 Ninguna";
        break;
      case "1":
        respuesta = "1 Unica";
        break;
      case "2":
        respuesta = "2 Inicial";
        break;
      case "3":
        respuesta = "3 Subcecuente";
        break;
      case "4":
        respuesta = "4 Alta Medica o ST-2";
        break;
      case "5":
        respuesta = "5 Valuación o ST-3";
        break;
      case "6":
        respuesta = "6 Defunción o ST-3";
        break;
      case "7":
        respuesta = "7 Pretanal";
        break;
      case "8":
        respuesta = "8 Enlace";
          break;
      case "9":
        respuesta = "9 PostNatal";
          break;
      default:
        break;
    }
    return respuesta;
  },
  /**
   *Función encargada de formatear el valor del tipo de trabajador
   * @param {*} valor 
   */
  formatoTipoTrabajador(valor) {
    let respuesta = "";
    if (servicioObjetos.esObjetoVacio(valor))
      return respuesta;
    valor = valor.trim();
    switch (valor) {
      case "1":
        respuesta = "PERMANENTE";
        break;
      case "2":
        respuesta = "EVENTUAL";
        break;
      case "3":
        respuesta = "EVENTUAL DE LA CONSTRUCCION";
        break;
      default:
        break;
    }
    return respuesta;
  },
  /**
  * Función encargada de formatear el tipo de jornada mediante el valor
   * @param {*} valor 
   */
  formatoTipoJornada(valor) {
    let respuesta = "";
    if (servicioObjetos.esObjetoVacio(valor))
      return respuesta;
    valor = valor.trim();
    switch (valor) {
      case "0":
        respuesta = "Jornada normal";
        break;
      case "1":
        respuesta = "Un día";
        break;
      case "2":
        respuesta = "Dos días";
        break;
      case "3":
        respuesta = "Tres días";
        break;
      case "4":
        respuesta = "Cuatro días";
        break;
      case "5":
        respuesta = "Cinco días";
        break;
      case "6":
        respuesta = "Jornada reducida";
        break;
      default:
        break;
    }
    return respuesta;
  },
  /**Función encargada de formatear el tipo de salario
   * @param {*} params 
   */
  formatoTipoSalario(valor) {    
    let respuesta = "";
    if (servicioObjetos.esObjetoVacio(valor))
      return respuesta;
    valor = valor.trim();
    console.log("valor:",valor);
    switch (valor) {
      case "0":
        respuesta = "Salario fijo";
        break;
      case "1":
        respuesta = "Salario variable";
        break;
      case "2":
        respuesta = "Salario mixto";
        break;
      default:
        break;
    }
    return respuesta;
  },
  /**
   * Función encargada de formatear la causa de baja de un trabajador
   * @param {*} valor 
   */
  formatoCausaBaja(valor) {
    let respuesta = "";
    if (servicioObjetos.esObjetoVacio(valor))
      return respuesta;
    valor = valor.trim();
    switch (valor) {
      case "1":
        respuesta = "Termino de contrato";
        break;
      case "2":
        respuesta = "Separación voluntaria";
        break;
      case "3":
        respuesta = "Abandono de empleo";
        break;
      case "4":
        respuesta = "Defunción";
        break;
      case "5":
        respuesta = "Clausura";
        break;
      case "6":
        respuesta = "Otras";
        break;
      case "7":
        respuesta = "Ausentismo";
        break;
      case "8":
        respuesta = "Rescisión de contrato";
        break;
      case "9":
        respuesta = "Jubilación";
        break;
      case "A":
        respuesta = "Pensión";
        break;
      default:
        break;
    }
    return respuesta;
  },
  /**
   * Función encargada de realizar el formateo del salario diario integrado
   * @param {*} valor 
   */
  formatoSalarioDiarioIntegradoString(valor) {
    if (servicioObjetos.esObjetoVacio(valor))
      return "";
    valor = valor.trim();
    if (valor.length !== 6)
      return "";
    let entero = valor.substring(0, 4);
    let decimal = valor.substring(4);
    return this.formatearModena(parseFloat(entero + "." + decimal))
  },

  formatoTipoIncidencia(valor) {
    let respuesta = "";
    if (servicioObjetos.esObjetoVacio(valor))
      return respuesta;
    if (typeof valor === 'number')
      valor = valor.toString();
    valor = valor.trim();
    switch (valor) {
      case "11":
        respuesta = "Ausentismo";
        break;
      case "12":
        respuesta = "Incapacidad";
        break;

      default:
        break;
    }
    return respuesta;
  },
  /**
   * Función encargada de realizar el formato de la fecha String del IDSE
   * @param {*} valor 
   */
  formatearFechaStringIdse(valor) {
    if (servicioObjetos.esObjetoVacio(valor))
      return "";
    let anio = valor.substring(4);
    let mes = valor.substring(2, 4);
    let dia = valor.substring(0, 2);
    let anioInt = parseInt(anio);
    let mesInt = parseInt(mes);
    let diaInt = parseInt(dia);
    let miFecha = new Date(anioInt, (mesInt - 1), diaInt, 6, 0, 0);
    return this.formatearFechaSinSegundos(miFecha.getTime());
  },
   
  filtroEstadoLote(estado) {
    if (servicioObjetos.esObjetoVacio(estado))
      return "";
    if (estado === 0)
      return "En proceso";
    if (estado === 1)
      return "Enviado al Imss";
    if (estado === 2)
      return "Respuesta del Imss";
  },
  filtroExtemporaneo(extemporaneo) {
    if (servicioObjetos.esObjetoVacio(extemporaneo))
      return "";
    extemporaneo = extemporaneo.trim();
    if (servicioObjetos.esObjetoVacio(extemporaneo))
      return "";
    if (extemporaneo === 0 || extemporaneo === "0")
      return "No";
    if (extemporaneo === 1 || extemporaneo === "1")
      return "Si";
  },
  filtroEstadoMovimiento(estadoRespuesta, fechaRespuesta) {
    if (estadoRespuesta === 0 && fechaRespuesta != null)
      return "Éxito";
    if (estadoRespuesta === 1 && fechaRespuesta != null)
      return "Error";
    if (estadoRespuesta === 0 && fechaRespuesta === null)
      return "En proceso";
  },
  /**
     * Método formatoEstadoCertificado --> 
     * Método que permite calcular la diferencia entre fechas (por horas).
     * Esto para saber si un certificado ya expiro, esta próximo a expirar o sigue vigente.
     * Donde:                  _
     *    1000 --> Milisegundos |
     *    60 --> Segundos       |-> Horas
     *    60 --> Minutos       _|
     * @param {*} rowData 
     * @param {*} column 
     */
  formatoEstadoCertificado(fechaFinal, estado) {
    
    
    let ahora = new Date();
    var fechaInicial = ahora.getTime();
    var diff = fechaFinal - fechaInicial;
    const diffDays = Math.ceil(diff / (1000 * 60 * 60 * 24));
    
    
    if (diffDays <= 0){
      return <p style={{ backgroundColor: '#f008', borderWidth: 1, borderColor: '#000', borderRadius: 12, padding: 8 }}>Expirado</p>;
    }
      if (diffDays >= 1 && diffDays <= 10){
      return <p style={{ backgroundColor: '#FF6900', borderWidth: 1, borderColor: '#000', borderRadius: 12, padding: 8 }}>Próximo a expirar</p>;
      }
      if(estado ===2){
        return <p style={{ backgroundColor: '#f008', borderWidth: 1, borderColor: '#000', borderRadius: 12, padding: 8 }}>Revocado</p>;
      }
      
      if (diffDays > 10){ 
      return <p style={{ backgroundColor: '#ff9f00', borderWidth: 1, borderColor: '#000', borderRadius: 12, padding: 8 }}>Vigente</p>;
      }
      
    
    },

  /**
 * Función encargada de formatear al tipo de descuento 
 * @param {*} valor 
 */
  formatoTipoDescuento(valor) {
    let respuesta = "";
    if (servicioObjetos.esObjetoVacio(valor))
      return respuesta;
    valor = valor.trim();
    switch (valor) {
      case "1":
        respuesta = "Porcentaje";
        break;
      case "2":
        respuesta = "Cuota Fija";
        break;
      case "3":
        respuesta = "Factor Descuento";
        break;
      default:
        break;
    }
    return respuesta;
  },

  formatearNombreTrabajador(objTrabajador){
    return (servicioObjetos.stripToEmpty(objTrabajador.primerApellido) + " " + servicioObjetos.stripToEmpty(objTrabajador.segundoApellido) + " " + servicioObjetos.stripToEmpty(objTrabajador.nombre)).trim();
  }

}

export default servicioFormatos;